/* Colour swatches on product cards, drawn from the visitor's own recent copy (28 Sep 2026).

   Why: the Linkify Product Colors app draws card swatches in three rounds after the page has loaded -
   one product file per card (36 on a collection page), then the colour groups from its server, then one
   stock check per card - measured 4.5-5.5 s before the swatches show. This script does the same job in
   two rounds and keeps what it learnt, so later pages of the visit draw instantly:
     1. the theme marks every card data-linkify-pc (the app's own "already done" mark), so the app leaves
        the cards to us; each card carries its product id, so no product files are needed;
     2. cards whose colours this browser saw in the last 30 minutes are drawn at once, with no request;
     3. the others: ONE colour-group request (the app's own file, same address) and a few batched stock
        checks for the visitor's country, then drawn and remembered;
     4. anything that fails, or a card with no product id, is handed back to the app, which then works
        exactly as before. If this file never runs, a timer in theme.liquid hands every card back.
   The swatches are the app's own markup (same tags, same settings from the app's file), so the app's CSS
   and linkify-plp-switch.js ("+N", ring, click-switch, hover photo) treat them like the app's.
   Source of truth stays the app: groups, names and swatch images come from its file; the copy expires. */
(function () {
  'use strict';
  window.psbSwOn = true;
  var TTL = 30 * 60 * 1000;
  var S = window.Shopify || {};
  var SHOP = S.shop || '';
  var COUNTRY = (S.country || '').toUpperCase();
  var ROOT = (S.routes && S.routes.root) || '/';
  var KEY = 'psbSw1:' + COUNTRY;
  var CARD = '[data-psb-card]';

  function now() { return Date.now(); }
  function load() {
    try { var o = JSON.parse(localStorage.getItem(KEY) || 'null'); if (o && o.v === 1) return o; } catch (e) {}
    return { v: 1, prod: {}, grp: {}, av: {}, set: null };
  }
  function save(st) {
    var t = now(), k;
    for (k in st.prod) if (t - st.prod[k][1] > TTL) delete st.prod[k];
    for (k in st.av) if (t - st.av[k][1] > TTL) delete st.av[k];
    var used = {};
    for (k in st.prod) used[st.prod[k][0]] = 1;
    for (k in st.grp) if (!used[k]) delete st.grp[k];
    try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {}
  }
  var st = load();
  function fresh(rec) { return rec && now() - rec[1] <= TTL; }

  function poke() {   /* the app watches the page for added elements; one is enough to make it look again */
    try { var i = document.createElement('psb-poke'); i.hidden = true; document.body.appendChild(i); i.remove(); } catch (e) {}
  }
  function release(cards) {
    var n = 0;
    cards.forEach(function (c) {
      if (c.querySelector('webyze-linkify-product-colors')) return;
      c.removeAttribute('data-linkify-pc'); c.setAttribute('data-psb-sw', 'app'); n++;
    });
    if (n) poke();
  }

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function render(card, gid) {
    var sibs = st.grp[gid], s = st.set || {};
    if (!sibs || !sibs.length) return false;
    var list = sibs.filter(function (x) {
      var a = st.av[x[1]];
      if (!a || a[0] === -1) return false;              /* not published, or not sold where the visitor is */
      if (s.soldoutStyle === 3 && a[0] === 0) return false;
      return true;
    });
    if (!list.length) { card.setAttribute('data-psb-sw', 'none'); return true; }   /* the app would draw nothing either */
    var anchor = card.querySelector('webyze-product-colors-collection-anchor');
    if (!anchor) return false;
    var host = document.createElement('webyze-linkify-product-colors');
    var vars = {
      '--size': (s.collectionSize != null ? s.collectionSize : 26) + 'px',
      '--highlight-color': s.collectionHighlightColor || '#424242',
      '--alignment': s.collectionAlignment || 'left',
      '--gap': (s.collectionGap != null ? s.collectionGap : 50) / 100,
      '--tooltips-size': s.tooltipsSize != null ? s.tooltipsSize : 1,
      '--tooltips-gap': (s.tooltipsGap != null ? s.tooltipsGap : 4) + 'px',
      '--label-font-size': (s.labelFontSize != null ? s.labelFontSize : 14) + 'px',
      '--label-font-weight': s.labelFontWeight || 'normal',
      '--label-color': s.labelColor || '#000000',
      '--label-alignment': s.labelAlignment || 'left',
      '--label-gap': (s.labelGap != null ? s.labelGap : 5) + 'px'
    };
    for (var v in vars) host.style.setProperty(v, vars[v]);
    if (s.collectionTheme) host.setAttribute('data-theme', s.collectionTheme);
    if (s.tooltipsStyle) host.setAttribute('data-tooltips-style', s.tooltipsStyle);
    if (s.showTooltips !== false) host.setAttribute('data-tooltips', '');
    if (s.soldoutStyle) host.setAttribute('data-soldout-style', s.soldoutStyle);
    host.setAttribute('data-collection', '');
    host.setAttribute('data-psb-server', '');     /* full colour list: linkify-plp-switch.js counts "+N" from it */
    host.setAttribute('data-psb-session', '');
    host.setAttribute('data-plp-ready', '');
    var html = '<linkify-product-colors-swatches>';
    list.forEach(function (x) {
      /* x = [product id, handle, name, type, data, image] */
      var type = x[3] || 'one_color', style;
      if (type === 'two_colors') { var two = String(x[4] || '').split('|'); style = '--color1: ' + (two[0] || '') + '; --color2: ' + (two[1] || '') + ';'; }
      else if (type === 'image') style = "--image: url('" + String(x[4] || '').replace(/'/g, "\\'") + "');";
      else style = '--color: ' + (x[4] || '') + ';';
      html += '<a href="' + esc(ROOT + 'products/' + x[1]) + '" class="swatch-crawlable-link" aria-label="' + esc(x[2]) + '" style="display: contents;">' +
        '<linkify-product-colors-swatch role="button" aria-label="' + esc(x[2]) + '" tabindex="0" data-type="' + esc(type) + '" data-handle="' + esc(x[1]) + '" style="' + esc(style) + '"' +
        (x[5] ? ' data-psb-image="' + esc(String(x[5]).split('?')[0]) + '"' : '') +
        (st.av[x[1]][0] === 0 ? ' data-soldout=""' : '') +
        '><linkify-product-colors-tooltip>' + esc(x[2]) + '</linkify-product-colors-tooltip></linkify-product-colors-swatch></a>';
    });
    host.innerHTML = html + '</linkify-product-colors-swatches>';
    anchor.parentNode.insertBefore(host, anchor);
    return true;
  }

  function groupsFetch(pids) {
    var url = 'https://s-pc.webyze.com/ProductColors/product-group.json?shop=' + encodeURIComponent(SHOP) + '&' +
      pids.map(function (p) { return 'prodId[]=' + p; }).join('&');
    return fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('groups ' + r.status); return r.json(); })
      .then(function (j) {
        if (!j || j.status !== 'success' || !Array.isArray(j.data)) throw new Error('groups: bad answer');
        var s = j.settings || {};
        if (s.version !== 2 || s.enableCollectionPages !== true) throw new Error('groups: collection swatches off');
        st.set = s;
        var t = now(), seen = {};
        j.data.forEach(function (g) {
          var gid = String(g.group_id);
          st.grp[gid] = (g.products || []).map(function (p) { return [String(p.id), p.handle, p.name || '', p.type || 'one_color', p.data, p.image || '']; });
          (g.products || []).forEach(function (p) { seen[String(p.id)] = gid; if (!fresh(st.prod[String(p.id)])) st.prod[String(p.id)] = [gid, t]; });
        });
        pids.forEach(function (p) { st.prod[p] = [seen[p] || 0, t]; });   /* 0 = in no colour group: nothing to draw */
      });
  }
  function stockFetch(handles) {
    var jobs = [];
    for (var i = 0; i < handles.length; i += 40) {
      (function (chunk) {
        var q = (COUNTRY ? 'query @inContext(country: ' + COUNTRY + ') {' : 'query {') +
          chunk.map(function (h, k) { return 'p' + k + ': product(handle: ' + JSON.stringify(h) + ') { availableForSale }'; }).join(' ') + '}';
        jobs.push(fetch('/api/2026-01/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ query: q }) })
          .then(function (r) { if (!r.ok) throw new Error('stock ' + r.status); return r.json(); })
          .then(function (j) {
            if (!j || !j.data) throw new Error('stock: bad answer');
            var t = now();
            chunk.forEach(function (h, k) { var p = j.data['p' + k]; st.av[h] = [p === null ? -1 : (p.availableForSale ? 1 : 0), t]; });
          }));
      })(handles.slice(i, i + 40));
    }
    return Promise.all(jobs);
  }

  function ready(gid) {   /* every colour of the group has a fresh stock answer */
    var g = st.grp[gid];
    if (!g) return false;
    for (var i = 0; i < g.length; i++) if (!fresh(st.av[g[i][1]])) return false;
    return true;
  }

  function run(cards) {
    var pending = [], giveBack = [];
    cards.forEach(function (c) {
      c.setAttribute('data-psb-sw', 'busy');
      var pid = c.getAttribute('data-product-id');
      if (!pid) { giveBack.push(c); return; }
      var rec = st.prod[pid];
      if (fresh(rec) && rec[0] === 0) { c.setAttribute('data-psb-sw', 'none'); return; }
      if (fresh(rec) && ready(rec[0]) && render(c, rec[0])) { if (c.getAttribute('data-psb-sw') === 'busy') c.setAttribute('data-psb-sw', 'saved'); return; }
      pending.push(c);
    });
    release(giveBack);
    if (!pending.length) { try { performance.mark('psb-swatches-session'); } catch (e) {} return; }
    var pids = [];
    pending.forEach(function (c) {
      var pid = c.getAttribute('data-product-id');
      if (!fresh(st.prod[pid]) && pids.indexOf(pid) < 0) pids.push(pid);
    });
    pids.sort(function (a, b) { return Number(a) - Number(b); });   /* same order as the app: same address, same cached file */
    (pids.length ? groupsFetch(pids) : Promise.resolve())
      .then(function () {
        var need = {};
        pending.forEach(function (c) {
          var rec = st.prod[c.getAttribute('data-product-id')];
          if (rec && rec[0] && st.grp[rec[0]]) st.grp[rec[0]].forEach(function (x) { if (!fresh(st.av[x[1]])) need[x[1]] = 1; });
        });
        var hs = Object.keys(need);
        return hs.length ? stockFetch(hs) : null;
      })
      .then(function () {
        var back = [];
        pending.forEach(function (c) {
          var rec = st.prod[c.getAttribute('data-product-id')];
          if (rec && rec[0] === 0) { c.setAttribute('data-psb-sw', 'none'); return; }
          if (rec && ready(rec[0]) && render(c, rec[0])) { if (c.getAttribute('data-psb-sw') === 'busy') c.setAttribute('data-psb-sw', 'fetched'); return; }
          back.push(c);
        });
        save(st);
        release(back);
        try { performance.mark('psb-swatches-session'); } catch (e) {}
      })
      .catch(function () { release(pending); });
  }

  /* ---- The colour row on the product page itself (28 Sep 2026) ----
     The app block adds {productId} to window.webyzeProductColorsQueue just before the app's script; a small
     hold in theme.liquid keeps that request. Here the row is drawn from the copy, or from ONE colour-group
     request (already preloaded on product pages) plus the stock check; if that cannot be done the request is
     handed back and the app draws the row exactly as before. Same place and markup as the app: before the
     first match of the app's own list of places (on this theme: .product-block .variant-wrapper). */
  var ROW_AT = ['.product-info__block-item[data-block-id="variant_picker"]', '.product__block__variants', '.webyze-product-colors-placeholder',
    'variant-radios', 'variant-selects', '.product-form product-variants', 'options-selection', 'block-variant-picker', '.product-block .variant-wrapper'];
  function rowTarget() {
    for (var i = 0; i < ROW_AT.length; i++) { var el = document.querySelector(ROW_AT[i]); if (el) return el; }
    return null;
  }
  function give(it) { if (window.psbSwRelease) window.psbSwRelease([it]); }
  function swatchStyle(x) {
    var type = x[3] || 'one_color';
    if (type === 'two_colors') { var two = String(x[4] || '').split('|'); return '--color1: ' + (two[0] || '') + '; --color2: ' + (two[1] || '') + ';'; }
    if (type === 'image') return "--image: url('" + String(x[4] || '').replace(/'/g, "\\'") + "');";
    return '--color: ' + (x[4] || '') + ';';
  }
  function renderRow(pid, gid) {
    var sibs = st.grp[gid], s = st.set || {};
    if (!sibs || !sibs.length) return false;
    var anchor = document.querySelector('webyze-product-colors-anchor[data-product="' + pid + '"]');
    var target = anchor || rowTarget();
    if (!target) return false;
    var list = sibs.filter(function (x) { var a = st.av[x[1]]; return a && a[0] !== -1 && !(s.soldoutStyle === 3 && a[0] === 0); });
    if (!list.length) return false;
    var host = document.createElement('webyze-linkify-product-colors');
    var vars = {
      '--size': (s.size != null ? s.size : 26) + 'px', '--highlight-color': s.highlightColor || '#424242', '--alignment': s.alignment || 'left',
      '--gap': (s.gap != null ? s.gap : 50) / 100, '--tooltips-size': s.tooltipsSize != null ? s.tooltipsSize : 1,
      '--tooltips-gap': (s.tooltipsGap != null ? s.tooltipsGap : 4) + 'px', '--label-font-size': (s.labelFontSize != null ? s.labelFontSize : 14) + 'px',
      '--label-font-weight': s.labelFontWeight || 'normal', '--label-color': s.labelColor || '#000000', '--label-alignment': s.labelAlignment || 'left',
      '--label-gap': (s.labelGap != null ? s.labelGap : 5) + 'px'
    };
    for (var v in vars) host.style.setProperty(v, vars[v]);
    if (s.marginTop != null) host.style.setProperty('margin-top', s.marginTop + 'px');
    if (s.marginBottom != null) host.style.setProperty('margin-bottom', s.marginBottom + 'px');
    if (s.theme) host.setAttribute('data-theme', s.theme);
    if (s.tooltipsStyle) host.setAttribute('data-tooltips-style', s.tooltipsStyle);
    if (s.showTooltips !== false) host.setAttribute('data-tooltips', '');
    if (s.soldoutStyle) host.setAttribute('data-soldout-style', s.soldoutStyle);
    host.setAttribute('data-psb-session', '');
    host.setAttribute('data-plp-ready', '');
    var cur = null;
    list.forEach(function (x) { if (x[0] === String(pid)) cur = x; });
    var html = '';
    if (s.showLabel) {
      html += '<label><linkify-product-colors-label>' + esc(s.labelText != null ? s.labelText : 'Color') + '</linkify-product-colors-label>' +
        (s.showLabelValue ? '<linkify-product-colors-label-value>' + esc(cur ? cur[2] : '') + '</linkify-product-colors-label-value>' : '') + '</label>';
    }
    html += '<linkify-product-colors-swatches>';
    list.forEach(function (x) {
      html += '<a href="' + esc(ROOT + 'products/' + x[1]) + '" class="swatch-crawlable-link" aria-label="' + esc(x[2]) + '" style="display: contents;">' +
        '<linkify-product-colors-swatch role="button" aria-label="' + esc(x[2]) + '" tabindex="0" data-type="' + esc(x[3] || 'one_color') + '" data-handle="' + esc(x[1]) + '" style="' + esc(swatchStyle(x)) + '"' +
        (x[0] === String(pid) ? ' data-selected=""' : '') + (st.av[x[1]][0] === 0 ? ' data-soldout=""' : '') +
        '><linkify-product-colors-tooltip>' + esc(x[2]) + '</linkify-product-colors-tooltip></linkify-product-colors-swatch></a>';
    });
    host.innerHTML = html + '</linkify-product-colors-swatches>';
    if (anchor) { anchor.insertAdjacentElement('afterend', host); anchor.remove(); }
    else target.insertAdjacentElement('beforebegin', host);
    return true;
  }
  function groupOne(pid) {
    var url = 'https://s-pc.webyze.com/ProductColors/product-group.json?shop=' + encodeURIComponent(SHOP) + '&prodId=' + pid;
    return fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('group ' + r.status); return r.json(); })
      .then(function (j) {
        if (!j || j.status !== 'success') throw new Error('group: bad answer');
        var s = j.settings || {};
        if (s.version !== 2) throw new Error('group: old settings version');
        st.set = s;
        var g = Array.isArray(j.data) ? j.data[0] : j.data, t = now();
        if (!g || g.group_id == null) { st.prod[String(pid)] = [0, t]; return; }
        var gid = String(g.group_id);
        st.grp[gid] = (g.products || []).map(function (p) { return [String(p.id), p.handle, p.name || '', p.type || 'one_color', p.data, p.image || '']; });
        (g.products || []).forEach(function (p) { st.prod[String(p.id)] = [gid, t]; });
        st.prod[String(pid)] = [gid, t];
      });
  }
  function row(it) {
    var pid = String(it && it.productId || '');
    if (!pid || !(document.querySelector('webyze-product-colors-anchor[data-product="' + pid + '"]') || rowTarget())) { give(it); return; }
    function draw() {
      var r = st.prod[pid];
      if (r && r[0] && ready(r[0]) && renderRow(pid, r[0])) { try { performance.mark('psb-row-session'); } catch (e) {} return; }
      give(it);   /* no colour group, nothing sold here, or no place for it: the app decides, as before */
    }
    var rec = st.prod[pid];
    if (fresh(rec) && rec[0] && ready(rec[0])) { draw(); return; }
    (fresh(rec) && rec[0] ? Promise.resolve() : groupOne(pid))
      .then(function () {
        var r = st.prod[pid];
        if (!r || !r[0] || !st.grp[r[0]]) return null;
        var need = st.grp[r[0]].filter(function (x) { return !fresh(st.av[x[1]]); }).map(function (x) { return x[1]; });
        return need.length ? stockFetch(need) : null;
      })
      .then(function () { save(st); draw(); })
      .catch(function () { give(it); });
  }
  function rows() {
    var held = window.psbSwHeld || [];
    var items = held.splice(0, held.length);
    window.psbSwAfter = row;   /* requests added later (a quick view, say) go straight through here */
    items.forEach(row);
  }

  function scan(root) {
    var list = [];
    (root || document).querySelectorAll(CARD).forEach(function (c) {
      if (c.hasAttribute('data-psb-sw')) return;
      if (c.querySelector('webyze-linkify-product-colors')) { c.setAttribute('data-psb-sw', 'copied'); return; }   /* a cloned card that already has swatches */
      list.push(c);
    });
    if (list.length) run(list);
  }

  try {
    if (!SHOP) { release([].slice.call(document.querySelectorAll(CARD))); if (window.psbSwRelease) window.psbSwRelease(); return; }
    rows();
    scan(document);
    var t = null;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { clearTimeout(t); t = setTimeout(function () { scan(document); }, 30); return; }
      }
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  } catch (e) {
    release([].slice.call(document.querySelectorAll(CARD)));
    if (window.psbSwRelease) window.psbSwRelease();
  }
})();
